// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"660":"131e2764","732":"8db335ba","977":"39c3f7e8"}[chunkId] + ".chunk.js";
};